// One policy for the designer, Shopify bridge and server clock.
const NeonRushPolicy = (() => {
  const timeZone = 'America/New_York', version = 'rush-et-2pm-v1';
  const hour = 3600000;
  const copy = 'Rush fabrication: your sign is usually ready in 24–48 hours after payment and artwork approval. Complete both before 2 p.m. Eastern Time. At or after 2 p.m., production starts the following day. Standard production is usually 10–14 days. Shipping time is additional.';
  const formatter = new Intl.DateTimeFormat('en-US', {timeZone, year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23'});
  function parts(value) {
    return Object.fromEntries(formatter.formatToParts(new Date(value)).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
  }
  const pad = value => String(value).padStart(2, '0');
  function date(value) {const p = parts(value);return `${p.year}-${pad(p.month)}-${pad(p.day)}`;}
  function validDate(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    const d = new Date(value + 'T12:00:00Z');
    return Number.isFinite(d.getTime()) && d.toISOString().slice(0,10) === value;
  }
  function addDays(value, count) {
    const d = new Date(value + 'T12:00:00Z');d.setUTCDate(d.getUTCDate() + count);return d.toISOString().slice(0,10);
  }
  function atEastern(value, h = 14) {
    if (!validDate(value)) return NaN;
    const [year, month, day] = value.split('-').map(Number), target = Date.UTC(year,month-1,day,h);
    let guess = target;
    for (let i=0;i<4;i++) {
      const p=parts(guess), actual=Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second);
      const delta=target-actual;guess+=delta;if(!delta)break;
    }
    return guess;
  }
  function formatDate(value) {
    return validDate(value) ? new Intl.DateTimeFormat('en-US',{timeZone,weekday:'short',month:'short',day:'numeric',year:'numeric'}).format(new Date(atEastern(value))) : '';
  }
  function windowFor(value=Date.now()) {
    const now=Number(value);if(!Number.isFinite(now))throw Error('A valid clock is required.');
    const today=date(now), cutoff=atEastern(today), afterCutoff=now>=cutoff;
    const productionStart=afterCutoff?atEastern(addDays(today,1)):now;
    const earliestReady=productionStart+48*hour;
    let earliestDate=date(earliestReady);
    if(atEastern(earliestDate)<earliestReady)earliestDate=addDays(earliestDate,1);
    return {version,timeZone,serverNow:new Date(now).toISOString(),afterCutoff,cutoffAt:new Date(cutoff).toISOString(),productionStartsAt:new Date(productionStart).toISOString(),earliestReadyAt:new Date(earliestReady).toISOString(),earliestDate,earliestDateLabel:formatDate(earliestDate),copy};
  }
  const termsKey=(state,window)=>`${version}|${window.earliestDate}|${state.rushReadyDate||''}`;
  function validate(state, now=Date.now()) {
    const window=windowFor(now), result={...window,ready:false,reason:''};
    if(state?.rushFabrication!==true)return {...result,ready:true};
    if(!validDate(state.rushReadyDate))return {...result,reason:'Choose the date you need your sign ready.'};
    const selected=atEastern(state.rushReadyDate);
    if(selected<new Date(window.earliestReadyAt).getTime())return {...result,reason:`That date is too soon. The earliest available ready date is ${window.earliestDateLabel} at 2 p.m. Eastern Time. Allow the full 48-hour production window.`};
    if(state.rushTermsAccepted!==true||state.rushTermsKey!==termsKey(state,window))return {...result,reason:'Please confirm the rush timing and 2 p.m. Eastern cutoff before continuing.'};
    const paymentDeadline=Math.min(selected-48*hour,atEastern(addDays(state.rushReadyDate,-2)));
    return {...result,ready:true,selectedReadyAt:new Date(selected).toISOString(),paymentDeadlineAt:new Date(paymentDeadline).toISOString(),selectedDateLabel:formatDate(state.rushReadyDate)};
  }
  function summary(state) {
    if(state?.rushFabrication!==true)return ['Standard fabrication: usually 10–14 days. Shipping time is additional.'];
    return [copy,`Requested fabrication ready date: ${formatDate(state.rushReadyDate)||'Not selected'} at 2 p.m. Eastern Time.`, 'The date is for fabrication readiness. Arrival and faster shipping must be confirmed separately.', 'Rush timing must be rechecked when payment and artwork approval are complete.'];
  }
  return Object.freeze({timeZone,version,copy,date,validDate,addDays,atEastern,formatDate,windowFor,termsKey,validate,summary});
})();

if(typeof module!=='undefined')module.exports=NeonRushPolicy;

